// THIS PROGRAM IS TO RAISE A HELPDESK REQUEST FROM PE SIDE
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { APIHelpdeskService } from '../../_services/helpdesk/API-helpdesk';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router, ActivatedRoute } from '@angular/router';

export interface issueCategory {
  value: string;
  viewValue: string
}

@Component({
  selector: 'app-capture-request-onpe',
  templateUrl: './capture-request-onpe.component.html',
  styleUrls: ['./capture-request-onpe.component.css']
})
export class CaptureRequestOnPEComponent implements OnInit {

  //PE registration, TM registration, TA registration, Header Registration, Consent Template, Content template, GST , Payment link, Login details reset, Certificate, Others


  issueCategories: issueCategory[] = [
    { value: 'PE Registration', viewValue: 'PE Registration' },
    { value: 'TM registration', viewValue: 'TM registration' },
    { value: 'TA registration', viewValue: 'TA registration' },
    { value: 'Header Registration', viewValue: 'Header Registration' },
    { value: 'Consent Template', viewValue: 'Consent Template' },
    { value: 'Content Template', viewValue: 'Content Template' },
    { value: 'GST', viewValue: 'GST' },
    { value: 'Payment link', viewValue: 'Payment link' },
    { value: 'Login details reset', viewValue: 'Login details reset' },
    { value: 'Certificate', viewValue: 'Certificate' },
    { value: 'Others', viewValue: 'Others' }
  ];
  entityForm: FormGroup;

  disableForm: boolean = false;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  EntityId: any;



  constructor(private fb: FormBuilder,
    private hlp: APIHelpdeskService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router) {

  }



  public POI: string;
  submitted: boolean = false;
  submitted1: boolean = false;
  formsubmitted: boolean = false;

  photoName: any;

  photoContent: any;
  fileExtension: any;
  fileExtensionError: boolean = false;
  fileExtensionMessage: any;
  get f() { return this.entityForm.controls; }

  myfiles: any[] = [];
  grouplist: any = [];
  ranvalue: any;

  ngOnInit() {
    
    this.entityForm = this.fb.group({

      RefNo: ['', ], 

      POI: ['', [Validators.maxLength(10), Validators.minLength(10), Validators.pattern('(^([a-zA-Z]){4}([0-9]{5})([a-zA-Z]){1}?$)|(^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$)')]],

      EmailID: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,5}$')]],
      DelNumber: ['', [Validators.required, Validators.maxLength(13), Validators.minLength(10), Validators.pattern('^[1-9][0-9]{9,12}$')]],//To allow from 10 to 13 digits
      Category: ['', [Validators.required]],//To allow from 10 to 13 digits

      Issue: ['', [Validators.required, Validators.maxLength(250), Validators.pattern('^(?! ).*(?<! )$')]],//To allow from 10 to 13 digits
      uploadKYC: ['',[]]//To allow from 10 to 13 digits

    });

    this.EntityId= this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    this.entityForm.controls['RefNo'].setValue(this.EntityId);

  }



  resetKYC() {
    console.log(this.entityForm.controls['uploadKYC'].value);
    this.entityForm.controls['uploadKYC'].reset();
    console.log(this.entityForm.controls['uploadKYC'].value);

    this.entityForm.controls['uploadKYC'].clearValidators();
    this.entityForm.controls['uploadKYC'].setValidators([Validators.required]);
    this.entityForm.controls['uploadKYC'].updateValueAndValidity();
    this.myfiles = [];
  }



  fileEvent(event): any {
    var file = event.target.files[0];
    this.photoName = file.name;

    var allowedExtensions =
      ["jpg", "jpeg", "png", "jfif", "bmp", "svg", "pdf"];
    this.fileExtension = this.photoName.split('.').pop();
    console.log("checking : ", this.isInArray(allowedExtensions, this.fileExtension))
    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      alert("Invalid File 1 formate");
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""

    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      alert("Invalid File 2 formate");
      this.fileExtensionError = true;
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
  }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }



  onChangeFileUpload(event) {
    console.log("calling onChangeFileUpload")
    // this.myfiles = event.target.files;
    var file = event.target.files[0];
    this.photoName = file.name;
    console.log("the size is : ", file.size)
    let fileNameArr = file.name.split('.')
    if(fileNameArr.length>2){
      // this.fileDoubleExtensionError = true
      this.$modal.errorModal({
        title: 'Import Header',
        msg: 'File with double extension is not allowed!' 
      })
      this.resetKYC()
    }else{
      if (file.size > 4242880) {
        console.log("The size is more ")
        this.fileSizeError1 = true;
      }
      else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {
        console.log("The size is less ")
        this.fileSizeError2 = true;
      }
      else {
        this.fileSizeError2 = false;
      }
      var allowedExtensions =
        ["jpg", "jpeg", "png", "jfif", "bmp", "svg", "pdf"];
      this.fileExtension = this.photoName.split('.').pop();
      console.log("this.photoName  :  ----------- ", this.photoName)
  
      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError = false;
        this.fileExtensionMessage = ""
        this.myfiles = event.target.files;
      } else {
        this.fileExtensionMessage = "Only photos allowed!!"
        this.fileExtensionError = true;
      }
  
      if (file) {
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        }
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
      console.log("this is file extension error ....", this.fileExtensionError);
    }
  }




  onSubmit() {
      this.submitted1 = true
      console.log("this.entityForm : ", this.entityForm)
      if (this.entityForm.invalid) {
      console.log("this.entityForm.invalid ")
      this.disableForm = true;
      let invalid = [];
      let controls = this.entityForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
          console.log(invalid);
             }
        }
        return;
      }
      else if (this.fileExtensionError || this.fileSizeError2 || this.fileSizeError1) {
      return;
    }


    else {
      this.formsubmitted = true
      const requestForm: FormData = new FormData();
      requestForm.append('RefNo', this.EntityId);
      requestForm.append('POI', this.entityForm.get("POI").value);
      requestForm.append('EmailID', this.entityForm.get("EmailID").value);
      requestForm.append('DelNumber', this.entityForm.get("DelNumber").value);
      requestForm.append('Category', this.entityForm.get("Category").value);
      requestForm.append('Issue', this.entityForm.get("Issue").value);
      requestForm.append('createdBy', this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID));

      requestForm.append('file', this.myfiles[this.myfiles.length - 1]);

      this.hlp.requestRegistration(requestForm)
        .subscribe(r => {
          console.log("r : ", r)
          if (r.status == "fail") {
            this.$modal.errorModal({
              title: 'Failed',
              msg: r.msg
            });
          }
          else if (r.status == "success") {
            this.$modal.successModal({
              title: 'Success',
              msg: r.msg
            });
            this.router.navigateByUrl('/request-status');
          }
          else {
            this.$modal.errorModal({
              title: 'Failed',
              msg: "Some Error Occured"
            });
          }

        })

    }
  }
}